import { ComponentRef } from '@wix/public-editor-platform-interfaces';
import { BaseSDKShape } from '../BaseSDKShape';
import { PlatformSDKShape } from '../PlatformSDKShape';
import {
  BindingTarget,
  IBindingsProvider,
  IDataBindingItem,
} from '../cmsBindings/types';
import { CmsBindingConnectionItem } from '../cmsBindings';

class BindingsProvider implements IBindingsProvider {
  #privateAPI: any;
  constructor(
    privateAPI: any,
    private editorPointer: any,
    private controllerRef: any,
    private dataItemTarget: BindingTarget,
    public name: string,
  ) {
    this.#privateAPI = privateAPI;
  }

  public select() {
    return this.#privateAPI.bindings.openDataBindingPanel(
      this.dataItemTarget.id,
    );
  }

  public createBinding(data: IDataBindingItem) {
    try {
      const created = this.#privateAPI.bindings.create(
        this.editorPointer,
        this.controllerRef,
        {
          key: this.dataItemTarget,
          role: data.role,
          config: data.config,
        },
      );

      return new CmsBindingConnectionItem(
        this.#privateAPI,
        this.editorPointer,
        this.dataItemTarget,
        created,
      );
    } catch {
      return null;
    }
  }
}

export class BindingsProvidersSDKShape extends BaseSDKShape {
  public async list(bindingTarget: BindingTarget) {
    const privateAPI = await this.getPlatformPrivateAPI();
    const editorPointer =
      await privateAPI.components.getSingleSelectedEditorPointer();

    if (!editorPointer) {
      return [];
    }

    const controllers =
      privateAPI.bindings.getBindableControllers(editorPointer);

    return controllers.map(
      (controller: any) =>
        new BindingsProvider(
          privateAPI,
          editorPointer,
          controller,
          bindingTarget,
          'dataBinding',
        ),
    );
  }
}

export default new PlatformSDKShape(BindingsProvidersSDKShape)
  .withPublicMethod('list')
  .build();
